module.exports = __webpack_public_path__ + "img/thankYouIcone.0aaac87e.svg";